// 含税劳务费请款审批状态
export const LaborFeeRequestStatusList = [
    { status: 0, label: '未开始', textType: 'secondary' },
    { status: 1, label: '待审批', textType: 'warning' },
    { status: 2, label: '同意', textType: 'success' },
];

// 劳务费付款状态
export const LaborFeePaymentStatusList = [
    { status: 0, label: '未付款' },
    { status: 1, label: '已付款' },
];

// 劳务费审核状态
export const LaborFeePaymentCheckList = [
    { status: 1, label: '有待审' },
    { status: 2, label: '无待审' },
];

// 会议执行类型
export const conferenceTypes = [
    { label: '线上', type: 1 },
    { label: '线下', type: 2 },
    { label: '线上+线下', type: 3 },
];
